<template>
  <v-form ref="registerForm" v-model="valid">
    <v-text-field
      v-model="name"
      prepend-icon="mdi-account"
      name="name"
      label="Name"
      :rules="nameRules"
      required
      @input="resetState"
    ></v-text-field>
    <v-text-field
      v-model="surname"
      prepend-icon="mdi-account"
      name="surname"
      label="Surame"
      :rules="surnameRules"
      required
      @input="resetState"
    ></v-text-field>
    <v-text-field
      v-model="organisation"
      prepend-icon="mdi-domain"
      name="organisation"
      label="Organisation"
      @input="resetState"
    ></v-text-field>
    <v-text-field
      v-model="email"
      prepend-icon="mdi-email"
      name="email"
      label="Email"
      type="email"
      :rules="emailRules"
      required
      @input="resetState"
    ></v-text-field>
    <v-text-field
      v-model="password"
      prepend-icon="mdi-lock"
      name="password"
      label="Password"
      type="password"
      required
      :error="passwordError"
      :error-messages="passwordErrorMessages"
      :rules="passwordRules"
      @input="resetState"
    ></v-text-field>
    <v-text-field
      v-model="repeatPassword"
      prepend-icon="mdi-lock"
      name="repeatPassword"
      label="Repeat password"
      type="password"
      required
      :error="passwordError"
      :error-messages="passwordErrorMessages"
      :rules="passwordRules"
      @input="resetState"
      @keydown.enter.stop="submitRegistration"
    ></v-text-field>

    <p
      class="text-center error--text"
      :style="{
        visibility: userRegistrationError ? 'visible' : 'hidden'
      }"
    >
      {{ userRegistrationError }}
    </p>
    <v-btn
      color="accent"
      :disabled="!valid"
      :loading="registerButtonLoading"
      @click="submitRegistration"
      >Submit</v-btn
    >
  </v-form>
</template>

<script>
export default {
  data() {
    return {
      name: "",
      surname: "",
      organisation: "",
      email: "",
      password: "",
      repeatPassword: "",
      emailRules: [
        v => !!v || "The email field cannot be empty",
        v => /.+@.+\..+/.test(v) || "The email address is not valid"
      ],
      passwordRules: [
        v => !!v || "The password field cannot be empty",
        v =>
          v.length >= 6 || "The password needs to be longer than 6 characters"
      ],
      nameRules: [
        v => !!v || "The name field cannot be empty",
        v => v.length >= 2 || "Please use your full name"
      ],
      surnameRules: [
        v => !!v || "The surname field cannot be empty",
        v => v.length >= 2 || "Please use your full surname"
      ],
      valid: false,
      passwordError: false,
      passwordErrorMessages: ""
    };
  },
  computed: {
    registerButtonLoading: {
      get: function() {
        return this.$store.state.registerButtonLoading;
      },
      set: function(value) {
        this.$store.state.registerButtonLoading = value;
      }
    },
    userRegistrationError: {
      get: function() {
        return this.$store.state.userRegistrationError;
      },
      set: function(value) {
        this.$store.state.userRegistrationError = value;
      }
    }
  },
  methods: {
    submitRegistration() {
      if (this.$refs.registerForm.validate() && this.passwordsMatch()) {
        this.registerButtonLoading = true;
        this.$store
          .dispatch("userCreate", {
            email: this.email,
            password: this.password,
            name: this.name,
            surname: this.surname,
            organisation: this.organisation,
            justification: this.$store.state.accessJustification
          })
          .then(() => {
            if (this.$store.state.user) {
              this.$emit("registrationComplete");
            }
          });
      }
    },
    passwordsMatch() {
      if (this.password === this.repeatPassword) {
        return true;
      } else {
        this.passwordError = true;
        this.passwordErrorMessages = "The passwords do not match.";
        return false;
      }
    },
    resetState() {
      this.$store.state.userRegistrationError = "";
      this.passwordError = false;
      this.passwordErrorMessages = "";
    }
  }
};
</script>
